import { useEffect, useState } from 'react';
import { debounce } from 'utils/common';

export const useEditCoverImageWidth = () => {
  const [imageWrapperRef, setImageWrapperRef] = useState<HTMLElement | null>(null);
  const [imageWrapperWidth, setImageWrapperWidth] = useState(0);
  const [imageWrapperHeight, setImageWrapperHeight] = useState(0);

  useEffect(() => {
    const resizeEditor = debounce(() => {
      setImageWrapperWidth(imageWrapperRef?.offsetWidth || 0);
      setImageWrapperHeight(imageWrapperRef?.offsetHeight || 0);
    }, 300);

    window.addEventListener('resize', resizeEditor);

    return () => {
      window.removeEventListener('resize', resizeEditor);
    };
  }, [imageWrapperRef?.offsetHeight, imageWrapperRef?.offsetWidth]);

  return {
    width: imageWrapperWidth || imageWrapperRef?.offsetWidth || 0,
    height: imageWrapperHeight || imageWrapperRef?.offsetHeight || 0,
    setImageWrapperRef,
  };
};
